export default {

  getPoints: state => state.points.toArray(),
  getEditMode: state => state.editMode, // 1: point, 2: text
}
